import { render, staticRenderFns } from "./WorkbenchImageUpload.vue?vue&type=template&id=71f63f9c&scoped=true"
import script from "./WorkbenchImageUpload.vue?vue&type=script&lang=js"
export * from "./WorkbenchImageUpload.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchImageUpload.vue?vue&type=style&index=0&id=71f63f9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f63f9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f63f9c')) {
      api.createRecord('71f63f9c', component.options)
    } else {
      api.reload('71f63f9c', component.options)
    }
    module.hot.accept("./WorkbenchImageUpload.vue?vue&type=template&id=71f63f9c&scoped=true", function () {
      api.rerender('71f63f9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/announcement/components/WorkbenchImageUpload.vue"
export default component.exports